<template>
   <p id="project-id" class="text-left text-bold">
      <span>Your Project Id is: </span>{{ projectStore.projectId }}
   </p>
   <TrackerInstuctions />
   <p>
      It may take up to 24 hours for data to arrive in your project. After
      you've installed the tracker, press the button below to continue.
   </p>
</template>
<script lang="ts" setup>
import TrackerInstuctions from "./TrackerInstructions.vue"
import { useProjectStore } from "@/stores/projectStore"
const projectStore = useProjectStore()
</script>
